import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function AdditionalAdminsStep({ formData, setFormData }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.additionalAdminEmails")}</h2>

      <input
        ref={inputRef}
        type="text"
        value={formData.additionalAdmins}
        onChange={e =>
          setFormData({
            ...formData,
            additionalAdmins: e.target.value
          })
        }
        placeholder={t("Start.separateEmailsWithCommas")}
      />

      <p className="muted">
        {t("Start.info.additionalAdmins")}
      </p>
    </>
  );
}
